import { render, staticRenderFns } from "./auditMessage.vue?vue&type=template&id=801fb9e0&"
import script from "./auditMessage.vue?vue&type=script&lang=js&"
export * from "./auditMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports